import { render, staticRenderFns } from "./genericPercentageCard.vue?vue&type=template&id=1a126d26&scoped=true&"
import script from "./genericPercentageCard.vue?vue&type=script&lang=js&"
export * from "./genericPercentageCard.vue?vue&type=script&lang=js&"
import style0 from "./genericPercentageCard.vue?vue&type=style&index=0&id=1a126d26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a126d26",
  null
  
)

export default component.exports